var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12780"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4766_4660)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 810",
    filter: "url(#filter0_f_4766_4660)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.247,
    cy: 11.1233,
    rx: 11.9927,
    ry: 13.6041,
    transform: "rotate(-55.565 16.247 11.1233)",
    fill: "#0109DF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 811",
    filter: "url(#filter1_f_4766_4660)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.2804,
    cy: 17.6696,
    rx: 11.8409,
    ry: 13.4368,
    transform: "rotate(-12.3631 10.2804 17.6696)",
    fill: "#2DFCFC",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 812",
    filter: "url(#filter2_f_4766_4660)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3574,
    cy: 18.3662,
    rx: 14.1487,
    ry: 11.6447,
    transform: "rotate(150 18.3574 18.3662)",
    fill: "url(#paint0_linear_4766_4660)",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4766_4660",
    x: 0.948535,
    y: -3.59395,
    width: 30.5971,
    height: 29.4345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09312,
    result: "effect1_foregroundBlur_4766_4660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4766_4660",
    x: -3.82747,
    y: 2.11309,
    width: 28.2156,
    height: 31.1132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09312,
    result: "effect1_foregroundBlur_4766_4660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4766_4660",
    x: 2.60186,
    y: 3.86016,
    width: 31.511,
    height: 29.0116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09312,
    result: "effect1_foregroundBlur_4766_4660"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4766_4660",
    x1: 7.26767,
    y1: 14.4171,
    x2: 27.5729,
    y2: 26.9577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C703F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACC3FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4766_4660"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.331299,
    y: 0.32959,
    width: 11.336,
    height: 11.336,
    rx: 5.668,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaraIcon);
export default __webpack_public_path__ + "static/media/nara-icon.8f6007354a32c0642c6d276a918fac30.svg";
export { ForwardRef as ReactComponent };